const monthNames = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
]

const getDateFromQueryPeriod = queryValue => {
  const rawPeriod = String(queryValue || '').split('&')[0].trim()
  if (!rawPeriod) return null

  const [rawMonth, rawYear] = rawPeriod.split('-')
  const month = Number(rawMonth)
  const year = Number(rawYear)

  if (!Number.isInteger(month) || month < 1 || month > 12) return null
  if (!Number.isInteger(year) || year < 1900) return null

  return `${year}-${String(month).padStart(2, '0')}-01`
}

export const getDocumentSourceDate = row => {
  const candidates = [
    row?.fechaEmision,
    row?.fechaDocumento,
    getDateFromQueryPeriod(row?.query),
    row?.fecha,
    row?.createAt,
    row?.createdAt,
    row?.fechaVencimiento
  ]

  return candidates.find(Boolean) || null
}

const formatPeriodLabel = rawDate => {
  if (!rawDate) return null

  const date = new Date(rawDate)
  if (Number.isNaN(date.getTime())) return null

  return `${monthNames[date.getUTCMonth()]} ${date.getUTCFullYear()}`
}

export const buildMassiveSelectionDebugRows = rows =>
  rows.map(row => {
    const sourceDate = getDocumentSourceDate(row)

    return {
      id: row?.id ?? null,
      idPrincipal: row?.idPrincipal ?? null,
      folio: row?.numeroFolio ?? null,
      documento: row?.nombreFolio ?? row?.nombreCuenta ?? null,
      razonSocial: row?.razonSocial ?? null,
      status: row?.status ?? null,
      fecha: row?.fecha ?? null,
      fechaEmision: row?.fechaEmision ?? null,
      fechaDocumento: row?.fechaDocumento ?? null,
      createAt: row?.createAt ?? null,
      createdAt: row?.createdAt ?? null,
      fechaVencimiento: row?.fechaVencimiento ?? null,
      fechaOrigenDetectada: sourceDate,
      periodoOrigenDetectado: formatPeriodLabel(sourceDate)
    }
  })

export const logMassiveLinkageDebug = ({
  scope,
  body,
  filterContext,
  selectedRows
}) => {
  const debugRows = buildMassiveSelectionDebugRows(selectedRows)

  console.groupCollapsed(`[${scope}] Vinculacion masiva`)
  console.table(debugRows)
  console.groupEnd()

  return debugRows
}
